"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyIssueExpertise = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.KeyIssueExpertise = {
  name: 'KeyIssueExpertise',
  scopeSlug: 'key-issue-expertise',
  nLabel: '%d Items',
  zeroLabel: 'No Items',
  oneLabel: '1 Item',
  table: {
    fieldNames: ["keyIssues", "levelOfExpertise"],
    options: {
      levelOfExpertise: {
        weight: 3
      }
    }
  },
  icon: function (_a) {
    var icons = _a.icons;
    return icons.StampedDocumentTickCircle;
  },
  form: {
    modal: {
      maxWidth: "900px"
    },
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      keyIssues: {
        type: 'linkedMultiple',
        required: true,
        entityTypeName: 'KeyIssue',
        description: 'Select the {{KEY_ISSUES}} that relate to the expertise or interest'
      },
      levelOfExpertise: {
        type: 'linked',
        entityTypeName: 'ExpertiseLevel',
        description: 'Choose the level of expertise or interest for the {{KEY_ISSUES}} selected above',
        required: true
      }
    })
  },
  autoRoutes: ['create', 'update']
};